<div class="container mt-4 mb-5">
  <div id="page-content-wrapper">
    <!-- Header Section -->
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-md-center bg-white p-4 rounded-4 shadow-sm border mb-4 sticky-top"
      style="z-index: 100;">
      <div class="mb-3 mb-md-0">
        <h4 class="fw-bold mb-1 text-primary"><i class="bi bi-download me-2"></i>{{ "Export" | translate }}</h4>
        <p class="text-secondary mb-0 small">
          {{"Selected"| translate}} <span class="fw-bold text-dark" *ngIf="bibs.length != 0;else count0">{{
            countselected }}</span>
          <ng-template #count0>0</ng-template>
          / <span class="fw-bold text-dark">{{ bibs.length }}</span> {{"Titles"| translate}}
        </p>
      </div>

      <div class="d-flex flex-wrap align-items-center gap-3" [formGroup]="FGcheckall">
        <!-- Select All Toggle -->
        <div class="form-check form-switch d-flex align-items-center gap-2 m-0 p-0 ps-5">
          <input (change)="selectAll($event)" class="form-check-input shadow-sm"
            style="cursor: pointer; width: 2.5em; height: 1.25em;" type="checkbox" role="switch" id="flexSwitchCheckAll"
            name="flexSwitchCheckAll" formControlName="checkall" />
          <label class="form-check-label small fw-bold text-secondary text-uppercase"
            style="cursor: pointer; letter-spacing: 0.05em;" for="flexSwitchCheckAll">
            {{"SelectAll" | translate}}
          </label>
        </div>

        <div class="vr h-100 mx-1 text-muted opacity-25 d-none d-md-block" style="min-height: 30px;"></div>

        <!-- Toolbar Actions -->
        <div class="d-flex gap-2">
          <div class="dropdown">
            <button
              class="btn btn-sm btn-light btn-light-walai border border-primary text-primary rounded-pill px-3 shadow-none gap-2 px-3 dropdown-toggle d-flex align-items-center gap-2"
              type="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="bi bi-download"></i>
              {{ "Export" | translate }}
            </button>

            <ul class="dropdown-menu shadow-lg border-0 rounded-4 mt-2" aria-labelledby="dropdownMenuLink">
              <li><a class="dropdown-item pointer small py-2" (click)="export('MARC')" data-bs-toggle="modal"
                  data-bs-target="#exportModal"><i class="bi bi-file-earmark-code me-2"></i>MARC</a></li>
              <li><a class="dropdown-item pointer small py-2" (click)="export('MARCISO2709')" data-bs-toggle="modal"
                  data-bs-target="#exportModal"><i class="bi bi-file-earmark-binary me-2"></i>ISO 2709</a></li>
              <li><a class="dropdown-item pointer small py-2" (click)="export('Bibliography')" data-bs-toggle="modal"
                  data-bs-target="#exportModal"><i class="bi bi-journal-text me-2"></i>Bibliography</a></li>
              <li><a class="dropdown-item pointer small py-2" (click)="export('ENDNOTE')" data-bs-toggle="modal"
                  data-bs-target="#exportModal"><i class="bi bi-file-earmark-text me-2"></i>ENDNOTE</a></li>
              <li><a class="dropdown-item pointer small py-2" (click)="export('DublinCore')" data-bs-toggle="modal"
                  data-bs-target="#exportModal"><i class="bi bi-file-earmark-text me-2"></i>Dublin Core</a></li>
              <li><a class="dropdown-item pointer small py-2" (click)="export('APAStyle')" data-bs-toggle="modal"
                  data-bs-target="#exportModal"><i class="bi bi-journal-richtext me-2"></i>APA Style</a></li>
              <li><a class="dropdown-item pointer small py-2" (click)="export('RISForZotero')" data-bs-toggle="modal"
                  data-bs-target="#exportModal"><i class="bi bi-file-earmark-zip me-2"></i>RIS for Zotero</a></li>
              <li><a class="dropdown-item pointer small py-2" (click)="export('RISForMendeley')" data-bs-toggle="modal"
                  data-bs-target="#exportModal"><i class="bi bi-file-earmark-zip me-2"></i>RIS for Mendeley</a></li>
            </ul>
          </div>

          <button type="button" (click)="deleteAll()"
            class="btn btn-sm btn-outline-danger rounded-pill px-3 d-flex align-items-center gap-2">
            <i class="bi bi-trash"></i> {{"Delete all" | translate}}
          </button>
        </div>
      </div>
    </div>

    <!-- Content List -->
    <div class="row">
      <div class="col-12">

        <!-- Empty State for Main List -->
        <div *ngIf="bibs.length === 0" class="text-center py-5 my-5">
          <div class="mb-4">
            <div
              class="d-inline-flex align-items-center justify-content-center bg-light rounded-circle shadow-sm position-relative"
              style="width: 100px; height: 100px;">
              <i class="bi bi-book-half text-secondary opacity-25" style="font-size: 4rem;"></i>
            </div>
          </div>
          <h4 class="text-secondary fw-bold mb-2">{{ 'EMPTY_SAVED_BOOKS_TITLE' | translate }}</h4>
          <p class="text-muted small mb-4 w-50 mx-auto">
            {{ 'EMPTY_SAVED_BOOKS_DETAIL' | translate }}
          </p>
          <a [routerLink]="['/results']" [queryParams]="{Ntk: 'KEYWORD', Ntt: '*'}"
            class="btn btn-primary rounded-pill px-4 py-2 shadow-sm transition-hover">
            <i class="bi bi-search me-2"></i> {{ 'EMPTY_GO_TO_SEARCH' | translate }}
          </a>
        </div>

        <ul class="list-unstyled d-flex flex-column gap-3" *ngIf="bibs.length > 0">
          <li *ngFor="let list of listckeckedselect; let i = index;"
            class="bg-white rounded-4 shadow-sm border p-4 position-relative overflow-hidden">
            <div class="row">
              <div class="col-12">
                <app-bibitem-card [bibid]="list.bib"></app-bibitem-card>
              </div>
            </div>

            <!-- Actions Footer: Aligned with details (offset-3) -->
            <div class="row mt-2">
              <div class="col-md-9 offset-md-3">
                <div class="d-flex align-items-center justify-content-end gap-3 border-top pt-3 border-light">
                  <div class="form-check form-switch d-flex align-items-center gap-2 m-0" style="min-height: auto;">
                    <input type="checkbox" class="form-check-input shadow-sm pointer" style="width: 2.5em;"
                      id="flexSwitchCheckChecked-{{i}}" [checked]="list.selected"
                      (change)="AddOrRemoveSeleted(list.bib, i)" />
                    <label class="form-check-label text-secondary small fw-bold text-uppercase pointer"
                      for="flexSwitchCheckChecked-{{i}}">
                      Select
                    </label>
                  </div>


                  <div class="vr text-secondary opacity-25" style="height: 20px;"></div>

                  <button type="button"
                    class="btn btn-sm btn-outline-danger rounded-pill px-4 d-flex align-items-center gap-2 transition-hover"
                    (click)="deleteBib(list.bib, i)">
                    <i class="bi bi-trash"></i>
                    <span class="fw-medium">{{'Delete' | translate}}</span>
                  </button>

                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="exportModal" tabindex="-1" aria-labelledby="eexportModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header border-bottom-0 pb-0">
        <h5 class="modal-title fw-bold text-primary" id="exportModalLabel">
          <i class="bi bi-download me-2"></i>Export : {{ exportType }}
        </h5>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- sinner -->
        <div class="row pb-5 pt-5" *ngIf="loading">
          <div class="col-md-12 text-center">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-3 text-muted small">Generating export data...</p>
            <!-- <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "square-jelly-box" [fullScreen] = "false"><p style="color: white" > Loading... </p></ngx-spinner> -->
          </div>
        </div>
        <div class="card card-body border-0 bg-light" *ngIf="!loading">

          <!-- Empty State for Modal -->
          <div
            *ngIf="(type !== 'MARC' && (!datalist || datalist.length === 0)) || (type === 'MARC' && (!dataMARClist || dataMARClist.length === 0))"
            class="d-flex flex-column align-items-center justify-content-center py-5 text-center">
            <div class="mb-3">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-white rounded-circle shadow-sm position-relative"
                style="width: 80px; height: 80px;">
                <i class="bi bi-file-earmark-x text-secondary opacity-50" style="font-size: 2.5rem;"></i>
              </div>
            </div>
            <h5 class="text-secondary fw-bold mb-2">{{ 'EMPTY_NO_DATA_TITLE' | translate }}</h5>
            <p class="text-muted small mb-0 w-75 mx-auto">
              {{ 'EMPTY_NO_DATA_DETAIL' | translate }}
            </p>
          </div>

          <div *ngIf="type!=='MARC' && datalist && datalist.length > 0">
            <ng-container *ngFor="let exp of datalist">
              <div class="bg-white p-3 rounded border shadow-sm mb-2" *ngFor="let item of exp.databib">
                <p [innerHTML]="item.data" class="mb-0"></p>
              </div>
            </ng-container>
          </div>

          <div *ngIf="type == 'MARC' && dataMARClist && dataMARClist.length > 0"
            class="table-responsive bg-white rounded border shadow-sm">
            <table class="table table-hover mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="py-3 ps-3 text-secondary border-bottom-0">Tag</th>
                  <th scope="col" class="py-3 text-center text-secondary border-bottom-0">Ind1</th>
                  <th scope="col" class="py-3 text-center text-secondary border-bottom-0">Ind2</th>
                  <th scope="col" class="py-3 text-secondary border-bottom-0">Subfield</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let exp of dataMARClist">
                  <tr *ngFor="let tag of exp">
                    <th scope="row" class="ps-3 text-primary font-monospace">{{ tag.TagID }}</th>
                    <td class="text-center font-monospace text-muted">{{ tag.Indicator1 }}</td>
                    <td class="text-center font-monospace text-muted">{{ tag.Indicator2 }}</td>
                    <td class="text-break">
                      <p style="max-width: 500px" [innerHTML]="tag.Subfield" class="mb-0"></p>
                    </td>
                  </tr>
                </ng-container>

              </tbody>
            </table>
          </div>


        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
        <!-- <button type="button" class="btn btn-primary" (click)="copyText()"> <i class='bx bx-copy-alt'></i> Copy</button> -->
        <button type="button" class="btn btn-primary" (click)="saveAsTextFile()">
          <i class="bi bi-file-earmark-arrow-down"></i> Save
        </button>
      </div>
    </div>
  </div>
</div>